var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.extData.tenderTermsId
    ? _c(
        "div",
        [
          _vm.allowEdit
            ? _c("HkldDropzone", {
                attrs: {
                  sourceId: _vm.extData.tenderTermsId,
                  action: _vm.ActionTypes.settings.doc.tender.create,
                  metaData: { uploadOnTop: true },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("EditTerms", {
            attrs: {
              sourceId: _vm.extData.tenderTermsId,
              canEdit: _vm.allowEdit,
              canDelete: _vm.allowEdit,
              canDownloadAll: false,
              action: _vm.ActionTypes.settings.doc.tender.delete,
              updateAction: _vm.ActionTypes.settings.doc.tender.edited,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }